import { createSelector } from '@reduxjs/toolkit';

import { reportsModel } from '@/entities/reports';
import { studyModel } from '@/entities/study';

import { RootState } from '@/app/model/store';

import { buildStructuredReportsAndStudies } from '../lib';

export const selectStructuredReportsAndStudiesByPatientID = (
  patientID: string,
) =>
  createSelector(
    studyModel.selectors.selectNotDeletedStudiesByPatientID(patientID),
    reportsModel.selectors.selectActiveReportsByPatientID(patientID),
    buildStructuredReportsAndStudies,
  );

export const selectHiddenStructuredReportsAndStudiesByPatientID = (
  patientID: string,
) =>
  createSelector(
    studyModel.selectors.selectNotDeletedStudiesByPatientID(patientID),
    reportsModel.selectors.selectHiddenReportsByPatientID(patientID),
    (studies, reports) => {
      const { sortedStructuredReportsAndStudies } =
        buildStructuredReportsAndStudies(studies, reports);

      return {
        // A hidden report whose studies were deleted too was removed by the
        // study/patient deletion cascade, not hidden by a doctor — keep it out.
        sortedStructuredReportsAndStudies:
          sortedStructuredReportsAndStudies.filter(
            (entry) => (entry.studies?.length ?? 0) > 0,
          ),
      };
    },
  );

export const selectLoading = (state: RootState) => state.reports.loading;
